import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '@Environments/environment';
import { GeneralApiEndpoints } from '@AppCore/constants/api-endpoints';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { HttpHelperService } from '@AppCore/services/http-helper.service';

import { Address, UserProfile } from '@AppRoot/shared/models/user.interface';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpHelperService,
    private globalUtilityService: GlobalUtilityService
  ) { }

  getUserProfile() {
    return this.http
      .get(
        `${environment.BASE_URL}${GeneralApiEndpoints.GET_USER_PROFILE}`,
        {},
        true
      )
      .pipe(
        catchError((error: any) => {
          throw new Error(error);
        })
      );
  }

  updateUserProfile(data: UserProfile) {
    this.globalUtilityService.showLoader();
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.UPDATE_USER_PROFILE}`,
        data,
        true
      )
      .pipe(
        tap(() => {
          this.globalUtilityService.hideLoader();
        }),
        catchError((error: any) => {
          this.globalUtilityService.hideLoader();
          throw new Error(error);
        })
      );
  }

  updateAddress(data: Address) {
    this.globalUtilityService.showLoader();
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.UPDATE_USER_ADDRESS}`,
        data,
        true
      )
      .pipe(
        tap(() => {
          this.globalUtilityService.hideLoader();
        }),
        catchError((error: any) => {
          this.globalUtilityService.hideLoader();
          throw new Error(error);
        })
      );
  }

  deleteAddress(data: { id: number }) {
    this.globalUtilityService.showLoader();
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.DELETE_USER_ADDRESS}`,
        data,
        true
      )
      .pipe(
        tap(() => {
          this.globalUtilityService.hideLoader();
        }),
        catchError((error: any) => {
          this.globalUtilityService.hideLoader();
          throw new Error(error);
        })
      );
  }

  updatePassword(data: {
    old_password: string;
    new_password: string;
    confirm_password: string;
  }) {
    this.globalUtilityService.showLoader();
    return this.http
      .post(
        `${environment.BASE_URL}${GeneralApiEndpoints.UPDATE_PASSWORD}`,
        data,
        true
      )
      .pipe(
        tap(() => {
          this.globalUtilityService.hideLoader();
        }),
        catchError((error: any) => {
          this.globalUtilityService.hideLoader();
          throw new Error(error);
        })
      );
  }

  getOrders() {
    return this.http
      .get(`${environment.BASE_URL}${GeneralApiEndpoints.GET_ORDERS}`, {}, true)
      .pipe(
        catchError((error: any) => {
          throw new Error(error);
        })
      );
  }


  getOrderDetails(order_id: string) {
    return this.http
      .get(`${environment.BASE_URL}${GeneralApiEndpoints.GET_ORDER_DETAILS}`, { order_id }, true)
      .pipe(
        catchError((error: any) => {
          throw new Error(error);
        })
      );
  }
}
